// Allows tab items to be navigated from URL hash
function tabAnchorClick(event: Event | null = null): void {
  if (window.location.hash) {
    const target = document.querySelector(`[data-wf-anchor="${window.location.hash.substring(1)}"]`);
    if (target instanceof HTMLElement) {
      target.click();
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  tabAnchorClick();
});

// Run when hash changes
window.addEventListener('hashchange', () => {
  tabAnchorClick();
});
